import Box from "@mui/material/Box";
import TextinputField from "../TextInputField/TextinputField";
import React, { useEffect, useRef, useState } from "react";
import { useTheme } from "../../../contexts/theme";
import {FormControl, Typography} from "@mui/material";
import Grid from "@mui/material/Grid";

interface GameTimeStyledComponentProps {
    gameTime: string;
    onChange: (val: string) => void;
}

const GameTimeStyledComponent = ({
                                     gameTime,
                                     onChange,
                                 }: GameTimeStyledComponentProps) => {
    const theme = useTheme();

    const [minutes, setMinutes] = useState("00");
    const [seconds, setSeconds] = useState("00");

    const maxMinutes = 199;
    const maxSeconds = 59;

    // --- sincronizza solo se viene da fuori (non durante editing) ---
    useEffect(() => {
        if (!gameTime) return;
        const [m = "0", s = "0"] = gameTime.split(":");
        setMinutes(m);
        setSeconds(s);
    }, [gameTime]);

    useEffect(() => {
        onChange(`${minutes}:${seconds}`);
    }, [minutes, seconds]);





    const handleChangeMinutes = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.currentTarget.value.replace(/\D/g, ""); // solo numeri
        const num = Math.min(Math.max(Number(value || 0), 0), maxMinutes);

        const formatted =
            num < 100 ? num.toString().padStart(2, "0") : num.toString();

        setMinutes(formatted);
    };

    const handleChangeSeconds = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.currentTarget.value.replace(/\D/g, "");
        const num = Math.min(Math.max(Number(value || 0), 0), maxSeconds);
        const formatted = num.toString().padStart(2, "0");
        setSeconds(formatted);
    };

    return (
        <Box>

        <Grid container spacing={2}>
            <Grid item xs={5.5}>
                <FormControl>
                    <TextinputField placeholder='Minutes' label={'Minutes'} type='number' variant={'outlined'}
                                    value={minutes}
                                    size={'medium'}
                                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {handleChangeMinutes(event)}}
                                    name={'index'}
                                    id={"outlined-basic"}
                                    borderBottomColor={theme.palette.orange}
                                    backgroundColor={'none'}
                                    color={theme.palette.white}
                                    borderColor={theme.palette.white}
                                    borderRadius={theme.border.width.hard}

                    ></TextinputField>
                </FormControl>
            </Grid>
            <Grid item xs={1}>
                <Typography variant="h4" component="h2" color={theme.palette.white} justifyContent="center" alignItems="center" display="flex">
                    :
                </Typography>

            </Grid>
            <Grid item xs={5.5}>
                <FormControl>
                    <TextinputField placeholder='Seconds' label={'Seconds'} type='number' variant={'outlined'}
                                    value={seconds}
                                    size={'medium'}
                                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {handleChangeSeconds(event)}}
                                    name={'index'}
                                    id={"outlined-basic"}
                                    borderBottomColor={theme.palette.orange}
                                    backgroundColor={'none'}
                                    color={theme.palette.white}
                                    borderColor={theme.palette.white}
                                    borderRadius={theme.border.width.hard}

                    ></TextinputField>
                </FormControl>
            </Grid>
        </Grid>


        </Box>
    );
};

export default GameTimeStyledComponent;
